// @mui material components
import { styled } from "@mui/material/styles";

export default styled("div")(({ theme }) => {
  const { palette, borders, typography, functions } = theme;

  const { borderRadius } = borders;
  const { size } = typography;
  const { text, background, grey } = palette;
  const { pxToRem } = functions;

  return {
    "& .quill": {
      display: "flex",
      flexDirection: "column",
    },

    "& .ql-toolbar": {
      borderRadius: `${borderRadius.md} ${borderRadius.md} 0 0`,
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: background.paper,
      borderBottomColor: grey[300],
      boxShadow: `0 ${pxToRem(4)} ${pxToRem(12)} rgba(0, 0, 0, 0.06)`,
    },

    "& .ql-container": {
      borderRadius: `0 0 ${borderRadius.md} ${borderRadius.md}`,
      maxHeight: "100%",
      overflowX: "hidden",
      overflowY: "visible",
    },

    "& .ql-editor": {
      minHeight: pxToRem(240),
      scrollMarginTop: pxToRem(64),

      "& p": {
        fontSize: size.md,
        color: text.main,
      },

      "& ul li": {
        color: text.main,
      },
    },

    "& .ql-tooltip": {
      left: "0 !important",

      "&.ql-hidden": {
        display: "none",
      },
    },
  };
});
